import { ComponentPropsWithoutRef } from 'react';

export const IconMinus = (props: ComponentPropsWithoutRef<'svg'>) => (
  <svg
    width="14"
    height="2"
    viewBox="0 0 14 2"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1 1H13"
      stroke="#E53E3E"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
